// extracted by mini-css-extract-plugin
export default {"container":"NoEvidenceView__container___jJ_WL","labels":"NoEvidenceView__labels___b8MW4","label":"NoEvidenceView__label___pa1mk"};